export default __webpack_public_path__ + "resources/icons/n600-fc2f.webp";